import {
    getChatLogPage,
    ubcLog,
} from '@lib/log';
import {getGlobalSettings} from '@lib/utils/native';
import deprecatedColors from '@src/theme/color.json';
import themeColors from '@src/theme/themeColor.json';
import themeImage from '@src/theme/themeImage.json';
import {isInNewApp} from './env';
import {appVersionCompare} from './tools';

interface Colors {
    [key: string]: {
        [key: string]: string;
    };
}

export enum FONT_LEVEL {
    Small = '1',
    Standard = '2',
    Big = '3',
    Biggest = '4',
    SuperBig = '5',
    Pc = 'pc',
}

export enum DEVICE_INFO {
    ios = 'ios',
    android = 'android',
}

export enum THEME_MODE {
    Light = 'light',
    Dark = 'dark',
}

export enum SKIN_MODE {
    /**
     * 极简版 - 对应3.0之前的default
     */
    Default = 'basic',
    /**
     * 极简版会员 - 对应3.0之前的vip
     */
    Vip = 'basicVip',
    /**
     * 青春版 - 3.0新增 - 3.0以后是默认皮肤
     */
    Youth = 'youth',
    /**
     * 青春版会员 - 3.0新增
     */
    YouthVip = 'youthVip',
    /**
     * 低版本vip - 暂时兼容，等3.0收敛以后删除
     */
    LowVip = 'vip',
    /**
     * pc客户端
     */
    PcClient = 'pcClient',
}

export enum TOKEN_TYPE {
    Theme = 'theme',
}

const level2scale: Record<string, number> = {
    '1': 0.94,
    '2': 1,
    '3': 1.06,
    '4': 1.21,
    '5': 1.41,
    'pc': 0.875,
    'pc_client': 15 / 17,
};
const sizeMap: Record<string, string> = {
    '1': 'small',
    '2': 'standard',
    '3': 'big',
    '4': 'biggest',
    '5': 'superbig',
};

export const getDefaultSkin = () => {
    if (!isInNewApp) {
        return SKIN_MODE.Youth;
    }
    return appVersionCompare('3.0') >= 0 ? SKIN_MODE.Youth : SKIN_MODE.Default;
};

export async function setPageFont(level?: FONT_LEVEL | string) {
    if (!level) {
        const getRes = await getGlobalSettings(['fontSize']);
        level = getRes?.data?.fontSize || '2';
        ubcLog({
            params: {
                type: 'show',
                value: 'font_size',
                page: getChatLogPage(),
            },
            ext: {
                element: sizeMap[level],
            },
        });
    }

    const scale = level2scale[level]; // / ratio;
    const $style = document.getElementById('self-define-font');
    if (!$style) {
        return;
    }
    let str = '';
    for (let fontsize = 10; fontsize <= 30; fontsize = fontsize + 0.5) {
        str += `--font${String(fontsize).replace('.', '_')}: ${Math.round(fontsize * scale * 100) / 10000}rem;`;
    }

    str += '--custom-vw: 1vw;';
    $style.innerText = ':root{' + str + '}';
}

// mode： light | dark
// skin: vip | basic - 3.0框架改版以前是这样
// 3.0框架改版需求，修改为https://ku.baidu-int.com/knowledge/HFVrC7hq1Q/qCCPuIpbfn/2bDtTCu3yf/ULdm3uJ3tboQQ-#anchor-fe4faba0-e35a-11ee-b28a-a96de65a34fb
// skin取值如下：
// basic - 极简版 basicVip - 极简会员版（对应原来的vip）
// youth - 青春版 youthVip - 青春会员版
export function setPageMode(mode: THEME_MODE, skin?: SKIN_MODE, tokenType?: TOKEN_TYPE) {
    let colorMap = themeColors as unknown as Colors;
    // 使用旧token
    if (!tokenType) {
        colorMap = deprecatedColors;
    }
    const imageMap = themeImage as unknown as Colors;
    // 当前skin的themeMode, vip-dark
    const curSkin = skin || SKIN_MODE.Default;
    const skinMode = `${curSkin}-${mode}`;
    // 对应skin的基础mode basic-(light,dark)
    const baseMode = `${SKIN_MODE.Default}-${mode}`;
    const currentColor = colorMap[skinMode];
    const baseColor = colorMap[baseMode];
    const currentImage = imageMap[skinMode];
    const baseImage = imageMap[baseMode];
    // __OFF_LINE__ && console.log('baseMode', baseMode, '   skinMode', skinMode);
    const $style = document.getElementById('self-define-style');
    if (!$style) {
        return;
    }
    let str = '';
    for (const key in baseColor) {
        if (baseColor.hasOwnProperty(key)) {
            const value = (currentColor && currentColor[key]) || baseColor[key];
            const resValue = value;
            str += `--${key}: ${resValue};`;
        }

    }
    if (tokenType) {
        // 新token模式下，添加image
        for (const key in baseImage) {
            if (baseImage.hasOwnProperty(key)) {
                const value = (currentImage && currentImage[key]) || baseImage[key];
                // const resValue = pathResolve(value);
                const resValue = value;
                str += `--${key}: ${resValue};`;
            }
        }
    }
    $style.innerText = ':root{' + str + '}';
}
